import {
  validateName,
  validateZipCode,
  validateState,
  validateAddress,
} from "_assets/js/helpers";

const hasStarted = (field) => {
  if (field !== undefined && field !== null) {
    return 1;
  }
  return 0;
};

export const validateLocation = (form) => {
  const isValid = {
    address: {
      started: hasStarted(form?.address),
      valid: validateAddress(form?.address) ? 1 : 0,
    },
    city: {
      started: hasStarted(form?.city),
      valid: validateName(form?.city) ? 1 : 0,
    },
    state: {
      started: hasStarted(form?.state),
      valid: validateState(form?.state) ? 1 : 0,
    },
    zip: {
      started: hasStarted(form?.zip),
      valid: validateZipCode(form?.zip) ? 1 : 0,
    },
  };

  let allValid = true;
  Object.keys(isValid).forEach((key) => {
    if (!isValid[key].valid) allValid = false;
  });
  isValid.allValid = allValid;

  return isValid;
};
